import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { DataLoadRequestedEvent } from '@platform/event-bus/domain/events/data-load-requested.event';
import { FetchServiceUseCase } from '@features/service/application/use-cases/fetch-service.use-case';

@Injectable({ providedIn: 'root' })
export class ServiceOnInitialDataDoneSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly fetchServiceUseCase = inject(FetchServiceUseCase);

  constructor() {
    this.eventBus.ofType(DataLoadRequestedEvent).pipe(
      switchMap(() => this.fetchServiceUseCase.execute()),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
